<app-icon-button-dialog
  [icon]="icon()"
  header="provider.tenders.phases.projectDescription"
  [tooltip]="statusKey()"
  [colorClass]="colorClass()"
  [disabled]="!hasProjectDescription()"
  (opened)="dialogOpened.set(true)"
>
  @if (tenderDetailsResource.isLoading()) {
    <app-loading />
  } @else if (tenderDetailsResource.value()) {
    <p-card class="w-full text-left">
      @if (phaseStatusInfo().phase === TenderPhaseType.RFI) {
        <app-tender-project-description-rfi [tenderDetails]="tenderDetailsResource.value()!" />
      } @else if (phaseStatusInfo().phase === TenderPhaseType.RFP) {
        <app-tender-project-description [tenderDetails]="tenderDetailsResource.value()!" />
      } @else if (phaseStatusInfo().phase === TenderPhaseType.RFD) {
        <app-tender-project-description [tenderDetails]="tenderDetailsResource.value()!" />
      } @else if (phaseStatusInfo().phase === TenderPhaseType.RFQ) {
        <app-tender-project-description-rfq [tenderDetails]="tenderDetailsResource.value()!" />
      } @else if (phaseStatusInfo().phase === TenderPhaseType.RFC) {
        <app-tender-project-description [tenderDetails]="tenderDetailsResource.value()!" />
      }
    </p-card>
  }
</app-icon-button-dialog>
